// reply to chat message state
// documentation link tbc

const state = {
  currentReplyMessage: null,
};

const getters = {
  getCurrentReplyMessage: (state) => state.currentReplyMessage,
};

const mutations = {
  setCurrentReplyMessage(state, data) {
    state.currentReplyMessage = data;
  },
};

const actions = {
  async updateCurrentReplyMessage({commit}, data) {
    commit('setCurrentReplyMessage', data)
  },
  async clearCurrentReplyMessage({commit}) {
    commit('setCurrentReplyMessage', null)
  },
  //reply to chat message functionality
  async replyToMessageHandler({dispatch}, data) {
    dispatch('updateCurrentReplyMessage', data)
  },
  async sendReplyToChatMessageHandler({getters,dispatch}, {content, replyTo}) {
    let data = {
      content,
      channelId: getters.getCurrentChatId,
      replyTo //message id
    }
    let res = await dispatch('api/chat/postMessage',data)
    dispatch('sendReplyToMessageCallback', res)
    return res
  },
  async sendReplyToMessageCallback({dispatch}, res) {
    if(res.success) {
      dispatch('clearCurrentReplyMessage')
      dispatch('analytics/sentChatMessage', ['Chat Reply Sent', res.success])
    } else {
      //show error
      dispatch('popups/chat/errorSendingMessage')
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
